import { render, staticRenderFns } from "./CommentsBody.vue?vue&type=template&id=a79a7956&"
import script from "./CommentsBody.vue?vue&type=script&lang=js&"
export * from "./CommentsBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports